import React, { useEffect, useRef, useState } from 'react';

import AssetService from '../../../shared/services/AssetService';
import ChangeFile from '../../../shared/components/ChangeFile';
import DefaultImage from '../../images/default-image.jpg';
import { FullwidthImageComponent } from '../../models/LessonComponent';
import styles from '../../styles/FullwidthImage.scss';
import { useLessonContext } from '../../models/LessonContext';
import useScreenSize from '../../hooks/useScreenSize';

interface FullwidthImageProps {
  component: FullwidthImageComponent;
}

export default function FullwidthImage(props: FullwidthImageProps) {
  const imageElement = useRef<HTMLImageElement>(null);
  const url = AssetService.getAssetUrl(props.component.settings.assetkey);
  const [aspectRatio, setAspectRatio] = useState(0);
  const [imageHeight, setImageHeight] = useState(0);
  const screenWidth = useScreenSize();
  const { mode } = useLessonContext();

  useEffect(() => {
    if (aspectRatio && props.component.settings?.imageHeight && screenWidth) {
      /* calculate the height in pixels relative to the image width */
      setImageHeight(
        screenWidth * aspectRatio * (props.component.settings.imageHeight / 100)
      );
    }
  }, [aspectRatio, props.component.settings?.imageHeight, screenWidth]);

  const onImageLoad = () => {
    const img = imageElement.current;
    setAspectRatio(img.naturalHeight / img.naturalWidth);
  };

  return (
    <div
      style={{
        width: '100%',
        height: `${Math.round(imageHeight)}px`,
        overflow: 'hidden',
        position: 'relative'
      }}
    >
      <img
        className={`${styles.image}`}
        ref={imageElement}
        onLoad={onImageLoad}
        style={{
          objectPosition: props.component.settings.imagePosition
        }}
        src={url || DefaultImage}
      />
      {mode === 'edit' && (
        <ChangeFile
          component={props.component}
          assetkey={props.component.settings.assetkey}
          assetTypes={['image']}
        />
      )}
    </div>
  );
}
